import { useTranslation } from "react-i18next";
import { useGetShopPoliciesQuery } from "@modules/shopify/hooks";
import { InfoArticle } from "@modules/shop/components/InfoPage/InfoArticle";
import type { GetShopPoliciesQuery } from "@gql/types";
import { getCountryVariables } from "@/modules/shared/localization/const/countries";

type PolicyKey = keyof Pick<
  GetShopPoliciesQuery["shop"],
  | "privacyPolicy"
  | "refundPolicy"
  | "shippingPolicy"
  | "termsOfService"
  | "contactInformation"
  | "legalNotice"
>;

interface InfoPolicyBodyProps {
  policyKey: PolicyKey;
  locale: string;
  titleKey?: string;
}

export function InfoPolicyBody({
  policyKey,
  locale,
  titleKey,
}: Readonly<InfoPolicyBodyProps>) {
  const { t } = useTranslation();
  const localeVars = getCountryVariables(locale);
  const { data, isLoading } = useGetShopPoliciesQuery(localeVars);
  const policy = data?.shop[policyKey];

  if (isLoading) {
    return (
      <div className="col-[10/39] py-[60px] laptop:col-[10/36] max-mobile:col-span-padded max-mobile:py-10">
        <div className="bg-background-3 mb-6 h-10 w-64 animate-pulse rounded" />
        <div className="space-y-3">
          <div className="bg-background-3 h-4 w-full animate-pulse rounded" />
          <div className="bg-background-3 h-4 w-5/6 animate-pulse rounded" />
          <div className="bg-background-3 h-4 w-4/6 animate-pulse rounded" />
        </div>
      </div>
    );
  }

  if (!policy) {
    return (
      <div className="col-[10/39] py-[60px] laptop:col-[10/36] max-mobile:col-span-padded max-mobile:py-10">
        <p className="text-text-3">Stranica nije pronađena.</p>
      </div>
    );
  }

  const title = titleKey ? t(titleKey) : policy.title;

  return <InfoArticle title={title} body={policy.body} locale={locale} />;
}
